import { render } from "./BaseCheckBox.vue?vue&type=template&id=81f4b4da&scoped=true"
import script from "./BaseCheckBox.vue?vue&type=script&lang=js"
export * from "./BaseCheckBox.vue?vue&type=script&lang=js"

import "./BaseCheckBox.vue?vue&type=style&index=0&id=81f4b4da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81f4b4da"]])

export default __exports__